import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

import { LatencyCard, LatencyTooltip } from './LatencyCard';
import { CHART_STYLES } from '../../Dashboard/constants/chartStyles';
import type { PercentilesResponse } from '../../../../../api';

type Props = {
  data?: PercentilesResponse | null;
  loading?: boolean;
  metricLabel: string;
  unit?: string;
};

const SERIES_COLORS = { p50: '#c4b5fd', p95: '#8884d8', p99: '#6d28d9' };

export const PercentilesByModelCard: React.FC<Props> = ({
  data,
  loading,
  metricLabel,
  unit = 'ms',
}) => {
  const chartData = (data?.items ?? []).map(item => ({
    name: item.group || 'unknown',
    p50: item.p50 ?? 0,
    p95: item.p95 ?? 0,
    p99: item.p99 ?? 0,
  }));

  return (
    <LatencyCard
      title={`${metricLabel} percentiles by model`}
      subtitle="p50 / p95 / p99"
      loading={loading}
      isEmpty={chartData.length === 0}
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={chartData}
          margin={{ top: 10, right: 20, left: 0, bottom: 20 }}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            stroke={CHART_STYLES.COLORS.GRID}
          />
          <XAxis
            dataKey="name"
            stroke={CHART_STYLES.COLORS.AXIS}
            fontSize={11}
            tickLine={false}
            axisLine={false}
            angle={-20}
            textAnchor="end"
            height={50}
          />
          <YAxis
            stroke={CHART_STYLES.COLORS.AXIS}
            fontSize={12}
            tickLine={false}
            axisLine={false}
            width={48}
          />
          <Tooltip
            cursor={{ fill: 'rgba(136,132,216,0.06)' }}
            isAnimationActive={false}
            content={<LatencyTooltip unit={unit} />}
          />
          <Legend />
          <Bar dataKey="p50" fill={SERIES_COLORS.p50} radius={[4, 4, 0, 0]} />
          <Bar dataKey="p95" fill={SERIES_COLORS.p95} radius={[4, 4, 0, 0]} />
          <Bar dataKey="p99" fill={SERIES_COLORS.p99} radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </LatencyCard>
  );
};
